import React from 'react';
import HelmetBuilder from '../components/helmet-builder';
import Hero from '../components/hero';
import ScrollButton from '../components/scroll-button';
import Main from '../components/main';
import Newsletter from '../components/newsletter';
import FromTheBlog from '../components/from-the-blog';

const IndexPage = ({ data, location }) =>
    <div className="home">
        <HelmetBuilder data={data.home.edges[0].node} pathname={location.pathname} />
        <Hero title="Know It Or Grow It" />
        <ScrollButton />
        {data.home.edges[0].node.homePageEntries.map((entry, idx) =>
            <Main key={idx} data={entry} hasLowerPadding={idx === data.home.edges[0].node.homePageEntries.length - 1} />
        )}
        <Newsletter home />
        <FromTheBlog data={data.fromTheBlog} />
    </div>;

export default IndexPage;

export const pageQuery = graphql`
    query HomePage {
        home: allContentfulHomePage {
            edges {
                node {
                    metadata {
                        title
                        description
                        ogimage {
                            file {
                                url
                            }
                        }
                        keywords
                    }
                    homePageEntries {
                        mainHeading
                        mainText {
                            mainText
                        }
                        mainVideoUrl
                        imageLinkUrl
                        callToActionText
                        callToActionUrl
                    }
                }
            }
        }
        fromTheBlog: allContentfulBlogPost(sort: { fields: [postDate], order: DESC }, limit: 2) {
            edges {
                node {
                    id
                    title
                    slug
                    category {
                        title
                    }
                    heroImage {
                        file {
                            url
                        }
                    }
                    introductoryQuote {
                        introductoryQuote
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js